import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { liveUpdates } from "@/mocks/mayiBaoliao";

const allCat = ["全部", "景区现场", "交通拥堵", "酒店踩雷", "游客见闻", "旅游乱象"];

export default function Timeline() {
  const [active, setActive] = useState("全部");
  const list = useMemo(
    () => (active === "全部" ? liveUpdates : liveUpdates.filter((u) => u.category === active)),
    [active]
  );

  return (
    <section id="live" className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          over="Liveflow · 实况快讯"
          title="滚动中的现场时间线"
          desc="按时间倒序更新的现场见闻与实况提示，按方向切换，挑你关心的看。"
        />

        {/* 方向筛选 */}
        <div className="mt-7 inline-flex max-w-full flex-wrap gap-1 rounded-full bg-background-50 p-1">
          {allCat.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition ${
                active === c
                  ? "bg-secondary-500 font-semibold text-background-50"
                  : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* 时间线 */}
        <div className="relative mt-8 border-l border-background-300 pl-5 md:pl-8">
          {list.map((u) => (
            <article key={u.time + u.title} className="relative pb-7 last:pb-0">
              <span className="absolute -left-[27px] top-1.5 h-3 w-3 rounded-full border-2 border-background-50 bg-secondary-400 md:-left-[39px]" />
              <div className="flex flex-col gap-1.5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-mono text-sm font-semibold text-foreground-950">{u.time}</span>
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-900">
                    {u.category}
                  </span>
                </div>
                <h3 className="font-medium leading-snug text-foreground-950">{u.title}</h3>
                <p className="max-w-2xl text-sm leading-relaxed text-foreground-600">{u.detail}</p>
              </div>
            </article>
          ))}
          {list.length === 0 && (
            <p className="text-sm text-foreground-500">该方向暂无最新实况，去看看别的方向吧。</p>
          )}
        </div>
      </div>
    </section>
  );
}